import { createContainer, createHook, createStore } from "react-sweet-state";

import {
    PricingPeriod,
    FormattedPriceCalculationResponse,
    CurrencyISOCode
} from "../constants";

import * as actions from "./actions";

export type PriceFinderState = {
    unitCount: number;
    billingCycle: PricingPeriod;
    priceCalcs: FormattedPriceCalculationResponse[];
    exampleMonthlyUnitCount: number;
    exampleAnnualUnitCount: number;
    currencyISOCode: CurrencyISOCode;
};

export const initialState: PriceFinderState = {
    unitCount: 0,
    billingCycle: "MONTHLY",
    priceCalcs: [],
    exampleMonthlyUnitCount: 0,
    exampleAnnualUnitCount: 0,
    currencyISOCode: "USD"
};

export const PriceFinderContainer = createContainer<PriceFinderState>();

const store = createStore({
    containedBy: PriceFinderContainer,
    name: "price-finder",
    initialState,
    actions,
    handlers: {
        onInit:
            () =>
            ({ setState }, state: PriceFinderState) => {
                setState({ ...state });
            }
    }
});

export const usePriceFinderStore = createHook(store);
